import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Released.module.sass";
import Card from "../../components/Card";
import Form from "../../components/Form";
import Market from "./Market";
import { GetCollections } from "../../Services/lib/nft";
import { UseApi } from "../../hooks/use-api";
import CollectionDetail from "./CollectionDetail";

export const PageLimit = 12;

const Released = () => {
	const [active, setActive] = useState();
	const [search, setSearch] = useState("");
	const [total, setTotal] = useState(1);
	const [page, setPage_] = useState(1);
	const [data, setData] = useState([]);
	const [filter, setFilter] = useState({
		page: page,
		limit: PageLimit,
		name: "",
		status: "RELEASED",
		order_direction: "ASC",
	});

	const [{ data: res, isLoading }, fetch] = UseApi({
		service: GetCollections,
	});

	const fetchCollections = () => {
		fetch(filter);
	};

	useEffect(() => {
		setData([]);
		fetchCollections();
	}, [filter]);

	const setPage = (e) => {
		setPage_(e);
		setFilter((p) => {
			return {
				...p,
				page: e,
			};
		});
	};

	useEffect(() => {
		if (res) {
			setTotal(Math.ceil(res.list_count / PageLimit));
			setData(res.list);
		}
	}, [res]);

	const handleSubmit = (e) => {
		e.preventDefault();
		setFilter((p) => {
			return {
				...p,
				name: e.target[0].value,
			};
		});
	};

	const closeProduct = () => {
		setActive();
	};

	const props = { total, page, setPage, isLoading, data, setActive };

	return active ? (
		<CollectionDetail data={active} closeProduct={closeProduct} />
	) : (
		<>
			<Card
				className={styles.card}
				classCardHead={styles.head}
				title="Minted drops"
				classTitle={cn("title-purple", styles.title)}
				head={
					<>
						<Form
							className={styles.form}
							value={search}
							setValue={setSearch}
							onSubmit={handleSubmit}
							placeholder="Search product"
							type="text"
							name="search"
							icon="search"
						/>
					</>
				}
			>
				<div className={styles.wrapper}>
					<Market {...props} />
				</div>
			</Card>
			{/* <Panel /> */}
		</>
	);
};

export default Released;
